import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-DiagnosisStatistics",
  "use": "icon-DiagnosisStatistics-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-DiagnosisStatistics\">\r\n  <path id=\"icon-DiagnosisStatistics_路径_36155\" data-name=\"路径 36155\" d=\"M20.047,0H3.953A3.964,3.964,0,0,0,0,3.953V20.047A3.964,3.964,0,0,0,3.953,24H20.047A3.964,3.964,0,0,0,24,20.047V3.953A3.964,3.964,0,0,0,20.047,0ZM8.645,16.447a.616.616,0,0,1-.616.616H6.755a.616.616,0,0,1-.616-.616V13.956a.616.616,0,0,1,.616-.616H8.03a.616.616,0,0,1,.616.616Zm4.579,0a.616.616,0,0,1-.616.616H11.341a.616.616,0,0,1-.616-.616v-5.51a.616.616,0,0,1,.616-.616h1.275a.616.616,0,0,1,.616.616Zm4.684.08a.616.616,0,0,1-.616.616H16.025a.616.616,0,0,1-.616-.616V6.78a.616.616,0,0,1,.616-.616H17.3a.616.616,0,0,1,.616.616Z\" fill=\"#fff\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/DiagnosisStatistics.svg
// module id = kOKf
// module chunks = 10